import * as React from "react";
import {useEffect, useState} from "react";
import Box from "@mui/material/Box";
import dayjs from "dayjs";
import axios from "axios";
import {getUrl} from "../../requests";
import DateRangePicker from "../DateRangePicker";
import {Button, Table} from "@mui/material";
import ErrorInfo, {ErrorInfoState} from "../../Components/UI/Info/ErrorInfo";
import SuccessInfo, {SuccessInfoState} from "../../Components/UI/Info/SuccessInfo";
import WarningInfo, {WarningInfoState} from "../../Components/UI/Info/WarningInfo";
import {LeadCountByEpid} from "./LeadCountByEpid";
import {LeadCountByVoivodeship} from "./LeadCountByVoivodeship";
import {DEF} from "../../const";
import {Libs} from "../../App/libs";
import css from "./LeadCounter.module.css"
import clsx from "clsx";


export default function LeadCounter(props) {
    const [dateFrom, setDateFrom] = useState(props?.dateFrom ? props.dateFrom : dayjs(new Date()).add(-2, "month").toDate());
    const [dateTo, setDateTo] = useState(props?.dateTo ? props?.dateTo : new Date());

    const [dateError, setDateError] = useState("");

    const [leadByEpidReport, setLeadByEpidReport] = useState([]);
    const [leadByVoivodeshipReport, setLeadByVoivodeshipReport] = useState([]);


    const [messageState, setMessageState] = useState(SuccessInfoState);
    const [messageEpidState, setMessageEpidState] = useState(SuccessInfoState);
    const [messageVoivodshipState, setMessageVoivodshipState] = useState(SuccessInfoState);

    const [errorState, setErrorState] = useState(ErrorInfoState);
    const [errorEpidState, setErrorEpidState] = useState(ErrorInfoState);
    const [errorVoivodshipState, setErrorVoivodshipState] = useState(ErrorInfoState);

    const [warningState, setWarningState] = useState(WarningInfoState);
    const [warningEpidState, setWarningEpidState] = useState(WarningInfoState);
    const [warningVoivodshipState, setWarningVoivodshipState] = useState(WarningInfoState);

    const [isInitialized, setIsInitialized] = useState(false);
    const [disableReport, setDisableReport] = useState(false);
    const [disableReportToDisk, setDisableReportToDisk] = useState(true);
    const [disableReportToGoogle, setDisableReportToGoogle] = useState(true);

    const [countByEpidNumber, setCountByEpidNumber] = useState(0);
    const [countByVoivodeshipNumber, setCountByVoivodeshipNumber] = useState(0);


    useEffect(() => {
        if(dateError) {
            setErrorState(errorState => ({...errorState, msg: dateError}));
            setDateError('');
        }
    }, [dateError]);

    useEffect(() => {
        if (isInitialized) {
            setDisableReportToDisk(true);
            setDisableReportToGoogle(true);
            clearNumbers();
            setLeadByEpidReport([]);
            setLeadByVoivodeshipReport([]);
        }
        setIsInitialized(true);
    }, [dateFrom, dateTo]);

    const aggregateByEpid = (data) => {
        let count = 0;
        data.map((rec, ix) => {
            count += rec.count;
        });
        setCountByEpidNumber(count);
    };

    const aggregateByVoivodeship = (data) => {
        let count = 0;
        data.map((rec, ix) => {
            count += rec.count;
        });
        setCountByVoivodeshipNumber(count);
    }

    const clearNumbers = (data) => {
        setCountByEpidNumber(0);
        setCountByVoivodeshipNumber(0);
    }

    const clearAllMessages = () => {
        setMessageState({...messageState, msg: ''});
        setMessageEpidState({...messageEpidState, msg: ''});
        setMessageVoivodshipState({...messageVoivodshipState, msg: ''});
        setWarningState({...warningState, msg: ''});
        setWarningEpidState({...warningEpidState, msg: ''});
        setWarningVoivodshipState({...warningVoivodshipState, msg: ''});
        setErrorState({...errorState, msg: ""});
        setErrorEpidState({...errorEpidState, msg: ""});
        setErrorVoivodshipState({...errorVoivodshipState, msg: ''});
    }

    const getJson = async () => {
        setLeadByEpidReport([]);
        setLeadByVoivodeshipReport([]);
        clearNumbers();
        setMessageState(messageState => ({...messageState,
            msg:"Generowanie raportu...",
            show: DEF.POPUP_SHOWING_INFINITE_TIME
        }));

        try {
            const request = {
                headers: {
                    Authorization: `Bearer ${props?.auth?.user}`,
                },
                params: {
                    dateFrom: dayjs(dateFrom).format(DEF.DATE_FORMAT),
                    dateTo: dayjs(dateTo).format(DEF.DATE_FORMAT),
                }
            };

            const response = await axios.get(`${getUrl()}/api/v1/reports/leads-taken-count-json`, request);
            clearAllMessages()

            if (response.status === 200 && response.data) {
                const data = response.data;

                if(Array.isArray(data.countByEpid) && data.countByEpid.length) {
                    setLeadByEpidReport(data.countByEpid);
                    aggregateByEpid(data.countByEpid);
                }

                if (Array.isArray(data.countByVoivodeship) && data.countByVoivodeship.length) {
                    setLeadByVoivodeshipReport(data.countByVoivodeship);
                    aggregateByVoivodeship(data.countByVoivodeship);
                }

                if (data.countByEpid.length || data.countByVoivodeship.length) {
                    setMessageEpidState(messageEpidState => ({
                        ...messageEpidState,
                        msg: 'Pobranych EPID: ' + data.countByEpid.length + '.'
                    }));
                    setMessageVoivodshipState(messageVoivodshipState => ({
                        ...messageVoivodshipState,
                        msg: 'Pobranych województw: ' + data.countByVoivodeship.length + '.'
                    }));

                    setDisableReportToDisk(false);
                    setDisableReportToGoogle(false);
                } else {
                    if (data.countByVoivodeship.length === 0 && data.countByVoivodeship.length === 0) {
                        setMessageState(messageState => ({...messageState, msg: ''}));
                        setWarningState(warningState => ({...warningState, msg: 'Brak danych.'}));
                        setDisableReportToDisk(true);
                        setDisableReportToGoogle(true);
                    } else if (data.countByEpid.length === 0) {
                        setMessageEpidState(messageEpidState => ({...messageEpidState, msg: ''}));
                        setWarningEpidState(warningEpidState => ({...warningEpidState, msg: "Brak danych."}));
                    } else if (data.countByVoivodeship.length === 0) {
                        setMessageVoivodshipState(messageVoivodshipState => ({
                            ...messageVoivodshipState,
                            msg: ''
                        }));
                        setWarningVoivodshipState(warningVoivodshipState => ({
                            ...warningVoivodshipState,
                            msg: "Brak danych."
                        }));
                    } else {
                    }

                }
            } else {
                const error = Libs.handleError(response);
                console.error(error);
                setMessageState(messageState => ({...messageState, msg: ''}));
                setErrorState(errorState => ({...errorState, msg: error.message}));
            }

        } catch(ex) {
            clearNumbers();
            clearAllMessages();
            const error = Libs.handleError(ex);
            console.error(error);
            setErrorState(errorState => ({...errorState, msg: error.message}));
            setMessageState(messageState => ({...messageState, msg: ''}));
            setLeadByEpidReport([]);
            setLeadByVoivodeshipReport([]);
        };
    };

    const getCsvFile = async () => {
        const dF = dayjs(dateFrom).format(DEF.DATE_FORMAT);
        const dT = dayjs(dateTo).format(DEF.DATE_FORMAT);
        const fileName = `leads-taken-count-${dF}-${dT}.csv`;
        setMessageState(messageState => ({...messageState,
            msg: "Pobieranie raportu...",
            show: DEF.POPUP_SHOWING_INFINITE_TIME
        }));

        try {
            const request = {
                responseType: "blob",
                headers: {
                    Authorization: `Bearer ${props?.auth?.user}`,
                },
                params: {
                    dateFrom: dF,
                    dateTo: dT,
                }
            };

            const response = await axios.get(`${getUrl()}/api/v1/reports/leads-taken-count-csv`, request);
            if(response.status === 200 )
            {
                const reader = new FileReader();
                reader.onloadend = () => {
                    const link = document.createElement('a');
                    link.href = reader.result;
                    link.download = fileName;

                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                };
                reader.readAsDataURL(new Blob([response.data], { type: 'text/csv' }));

                setMessageState(messageState => ({...messageState,
                    msg: 'Pobrano plik na dysk. ' + fileName,
                    show: DEF.POPUP_SHOWING_DEFAULT_TIME,
                }));
            } else {
                setErrorState(errorState => ({...errorState, msg: 'Błąd podczas pobierania pliku: ' + fileName,}));
                setMessageState(messageState => ({...messageState, msg: ''}));
            }
        } catch (ex) {
            console.error(ex);
            setErrorState(errorState => ({...errorState, msg: "Błąd podczas pobierania pliku: " + fileName}));
            setMessageState(messageState => ({...messageState, msg: ''}));
        }
    }

    const saveCsvToGDrive = async () => {
        const dF = dayjs(dateFrom).format(DEF.DATE_FORMAT);
        const dT = dayjs(dateTo).format(DEF.DATE_FORMAT);
        const fileName = `leads-taken-count-${dF}-${dT}.csv`;
        setMessageState(messageState => ({...messageState,
            msg: 'Przesyłanie raportu na Dysk Google...',
            show: DEF.POPUP_SHOWING_INFINITE_TIME,
        }));

        try {
            const request = {
                headers:
                {
                    Authorization: `Bearer ${props?.auth?.user}`,
                },
                params:
                {
                    dateFrom: dF,
                    dateTo: dT,
                }
            };

            const response = await axios.get(`${getUrl()}/api/v1/reports/leads-taken-count-csv-to-gdrive`, request);

            console.log(response);
            if (response.status === 200) {
                const link = <a href={response.data}
                                target="_blank"
                                rel="noopener noreferrer">Otwórz: {fileName}
                            </a>;

                setMessageState( messageState => ({...messageState,
                    msg: link,
                    show: DEF.POPUP_SHOWING_MANUAL_CLOSE,
                }));
            } else {
                console.error('Nie udało się wygenerować raportu.', response.status , response.data);
                setMessageState(messageState => ({...messageState, msg: ''}));
                setWarningState(warningState => ({...warningState,
                    msg:"Błąd podczas zapisywania pliku na gdrive: " + fileName,
                    show: DEF.POPUP_SHOWING_MANUAL_CLOSE
                }));
            }
        } catch (err) {
            console.error(err);
            setErrorState(errorState => ({...errorState,
                msg:"Błąd podczas zapisywania pliku na gdrive: " + fileName,
                show: DEF.POPUP_SHOWING_MANUAL_CLOSE,
            }));
            setMessageState(messageState => ({...messageState, msg: ''}));        }
    }

    return (
        <Box className={clsx(css.leadCounter)}>
            <Box className={clsx(css.controlPanel, 'controlPanel')}>
                <DateRangePicker
                    setDateFrom={setDateFrom}
                    setDateTo={setDateTo}
                    dateFrom={dateFrom}
                    dateTo={dateTo}
                    setDateError={setDateError}
                    inputFormat='YYYY-MM-DD'
                    mask='____-__-__'
                />
            
                <Button id='lead-counters-btn-get-json' className={clsx(css.button, 'button')}
                        variant="contained"
                        disabled={disableReport}
                        onClick={getJson}
                >
                    Generuj <br/> raport
                </Button>
            
                <Button id='lead-counters-btn-get-csv' className={clsx(css.button, 'button')}
                        variant="contained"
                        disabled={disableReportToDisk}
                        onClick={getCsvFile}
                >
                    Plik na <br/>dysk
                </Button>
            
                <Button id='lead-counters-btn-get-csv-to-gdrive' className={clsx(css.button, 'button')}
                        variant="contained"
                        disabled={disableReportToGoogle}
                        onClick={saveCsvToGDrive}
                >
                    Plik na <br/> google
                </Button>
            </Box>

            {errorState.msg && <ErrorInfo state={errorState} setState={setErrorState}/>}
            {warningState.msg && <WarningInfo state={warningState} setState={setWarningState}/>}
            {messageState.msg && <SuccessInfo state={messageState} setState={setMessageState}/>}

             <Box className={clsx(css.body, 'scrollable')}>

                 <Box className={clsx(css.epid)}>
                     <Box className={clsx(css.title)}>
                         Podjęte leady według EPID{<br/>}
                         Razem: {countByEpidNumber}
                     </Box>

                     {errorEpidState.msg && <ErrorInfo state={errorEpidState} setState={setErrorEpidState}/>}
                     {warningEpidState.msg && <WarningInfo state={warningEpidState} setState={setWarningEpidState}/>}
                     {messageEpidState.msg && <SuccessInfo state={messageEpidState} setState={setMessageEpidState}/>}

                     {leadByEpidReport.length > 0 && (
                         leadByEpidReport.map((record, index) => (
                             <Box className={clsx(css.counters)} key={index}>
                                 <LeadCountByEpid
                                     epid={record.epid}
                                     count={record.count}
                                 />
                             </Box>
                         ))
                     )}
                 </Box>

                 <Box className={clsx(css.space)}></Box>

                 <Box className={clsx(css.voivodeship)}>
                     <Box className={clsx(css.title)}>
                         Podjęte leady według województw{<br/>}
                         Razem: {countByVoivodeshipNumber}
                     </Box>

                     {errorVoivodshipState.msg && <ErrorInfo state={errorVoivodshipState} setState={setErrorVoivodshipState}/>}
                     {warningVoivodshipState.msg && <WarningInfo state={warningVoivodshipState} setState={setWarningVoivodshipState}/>}
                     {messageVoivodshipState.msg && <SuccessInfo state={messageVoivodshipState} setState={setMessageVoivodshipState}/>}

                     {leadByVoivodeshipReport.length > 0 && (
                         leadByVoivodeshipReport.map((record, index) => (
                             <Box className={clsx(css.counters)} key={index}>
                                 <LeadCountByVoivodeship
                                     voivodeship={record.voivodeship}
                                     count={record.count}
                                 />
                             </Box>
                         ))
                     )}
                 </Box>
             </Box>

        </Box>
    );
}